__turbopack_context__.v({
  "instructor-list-card": "instructor-list-module-scss-module__j9DWCa__instructor-list-card",
  "instructor-list-container": "instructor-list-module-scss-module__j9DWCa__instructor-list-container",
});
